import React from 'react';
import { ToolbarIconButton } from '@/widgets/tab/tab-toolbar/ui/ToolbarIconButton';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

/**
 * 간단한 아이콘 버튼을 생성하는 헬퍼
 */
export function toolbarAction(
  icon: OverridableComponent<SvgIconTypeMap>,
  tooltip: string,
  onClick: () => void,
  disabled: boolean = false
): React.ReactNode {
  return (
    <ToolbarIconButton
      icon={icon}
      tooltip={tooltip}
      size="small"
      onClick={onClick}
      disabled={disabled}
    />
  );
}
